<template>
  <div class="stack">
    <h3
      v-if="clist.length > 0"
      class="heading-xs"
    >
      We have found the following {{ clist.length > 1 ? clist.length + ' courses' : 'course' }}
    </h3>
    <div
      v-if="clist.length > 0"
      class="course-selector-card-list"
    >
      <Course
        v-for="(course, index) in displayList"
        :key="index"
        :course="course"
        :data-id="index"
      />

      <div
        v-if="clist.length > shownum"
        class="course-selector-card-list-span stack center"
      >
        <a
          href="#"
          class="button button-outline"
          @click.prevent="shownum += 6"
        >Show more</a>
      </div>
    </div>
    <template v-else>
      <p v-if="showintro" />
      <template v-else>
        <p
          v-if="atarval < 70"
        >
          Sorry, we don't have a course you can directly enter with that score. However, there are <a href="#pathways">other options</a> that may allow you to study here.
        </p>
        <p
          v-else
        >
          There are no courses that match this ATAR and filter combination.
        </p>
      </template>
    </template>
  </div>
</template>

<script>
import Course from './Course.vue'

export default {
  name: 'Courses',
  components: {
    Course
  },
  props: {
    atarval: {
      type: [Number, String],
      required: false,
      default: 0
    },
    showintro: {
      type: Boolean,
      required: false,
      default: false
    },
    clist: {
      type: Array,
      required: false,
      default: function () { return [] }
    }
  },
  data () {
    return {
      shownum: 6
    }
  },
  computed: {
    displayList: function () { // return updated list based on showmore input
      return this.clist.slice(0, this.shownum)
    }
  },
  watch: {
    clist: function (newVal, oldVal) { // watch list for updates then reset shownum to 6
      this.shownum = 6
    }
  },
  methods: {
    addMore () { // update showmore if user clicks button
      this.shownum += 6
    }
  }
}
</script>

<style lang="css">

</style>
